import './error404.scss'

import {wrap} from '@codeurs/front'
import {PageData} from 'campagne/types'
import React from 'react'
import {style} from 'util/campagne/style'
import {useLanguage, useTranslation} from 'util/i18n'
import {Layout} from 'views/campagne/layout'
import {Theme} from 'views/campagne/theme'

const styles = style('error')

export const Error404: React.FC<PageData> = wrap(Layout)(({...props}) => {
	const language = useLanguage()
	const t = useTranslation('campagne').error404

	return (
		<div class={styles}>
			<Theme.Container>
				<Theme.H1 class={styles('title')}>{t.title}</Theme.H1>
				<p class={styles('text')}>{t.text}</p>
				<Theme.Button class={styles('btn')} to={`/${language}`}>
					{t.btn}
				</Theme.Button>
			</Theme.Container>
		</div>
	)
})
